import { WeightUnitEnum } from "../routes/app/api/Representation";
import { nonEmpty } from "../swzutils";
import dayjs, { Dayjs } from "dayjs";
export const senderReceiverSummaryLine = (senderReceiver) => {
    if (!senderReceiver) {
        return '';
    }
    return senderReceiver?.companyName || addressSummaryLine(senderReceiver?.address) || '';
};
export const addressSummaryLine = (address) => {
    if (!address) {
        return '';
    }
    return nonEmpty `${address.unitOrFlat} ${address.street} ${address.suburb}`;
};
export const listFormat = (items, separator = ', ', penultimateSeparator = ', and ') => {
    let result = '';
    for (let i = 0; i < items.length; i++) {
        if (i != 0) {
            if (i == items.length - 1) {
                result += penultimateSeparator;
            }
            else {
                result += separator;
            }
        }
        result += items[i];
    }
    return result;
};
export const freightDescription = (freightItem) => {
    if (!freightItem) {
        return '';
    }
    let result = '';
    if (freightItem.description) {
        result = freightItem.description;
    }
    if (freightItem.productDescription) {
        result += ' ' + freightItem.productDescription;
    }
    if (freightItem.trackingCode) {
        result += ' - ' + freightItem.trackingCode;
    }
    return result.trim();
};
export const formatDistance = (meters, emptyVal = '') => {
    if (typeof meters !== 'number') {
        return emptyVal;
    }
    if (meters < 1000) {
        return meters + ' m';
    }
    if (meters < 10_000) {
        return Math.round(meters / 100) / 10 + ' km';
    }
    return Math.round(meters / 1000) + ' km';
};
export const capitalise = (val) => {
    return val.charAt(0).toUpperCase() + String(val).slice(1);
};
export const formatDimensions = (value) => {
    let result = '';
    if (value.length)
        result += value.length + 'L ';
    if (value.width)
        result += value.width + 'W ';
    if (value.height)
        result += value.height + 'H ';
    if (value.dimensionUnit)
        result += value.dimensionUnit.toLowerCase();
    return result;
};
export const formatDateTime = (value) => {
    if (!value) {
        return;
    }
    let dateTime = (typeof (value) === "string") ? dayjs(value) : value;
    return dateTime.format('DD/MM/YYYY HH:mm');
};
export const formatDate = (value) => {
    if (!value) {
        return;
    }
    let date = (typeof (value) === "string") ? dayjs(value) : value;
    return date.format('DD/MM/YYYY');
};
export const formatWeight = (value) => {
    if (value.weight && value.weightUnit) {
        return value.weight + ' ' + value.weightUnit.toLowerCase();
    }
    return null;
};
export const formatPartialISODateTime = (val) => {
    if (!val) {
        return '';
    }
    try {
        const pattern = /^(?<year>\d{4})(-(?<month>\d{2}))?(-(?<day>\d{2}))?T?(?<hour>\d{2})?$/;
        const groups = val.match(pattern)?.groups;
        if (!groups) {
            return val;
        }
        let result = "";
        if (groups.year != null) {
            result += groups.year;
        }
        if (groups.month != null) {
            result = groups.month + '/' + result;
        }
        if (groups.day != null) {
            result = groups.day + '/' + result;
        }
        if (groups.hour != null) {
            result += ' ' + groups.hour;
        }
        return result;
    }
    catch (e) {
        return val;
    }
};
export const formatName = (firstName, lastName) => {
    let result = '';
    if (firstName) {
        result += firstName;
    }
    if (lastName && lastName.length >= 1) {
        result += ' ' + lastName.substring(0, 1).toUpperCase();
    }
    return result;
};
